// routes/ProtectedRoutes.js
import AdminRoutes from './AdminRoutes';
import HRRoutes from './HRRoutes';
import AccountantRoutes from './AccountantRoutes';
import MainRoutes from './MainRoutes';

// Extract all protected routes from the route configurations
const extractRoutes = (routes) => {
  if (!routes || !routes.children) return [];
  
  return routes.children
    .filter(route => route.path && route.path !== '*' && route.path !== '/')
    .map(route => {
      // Handle paths that might start with '/' or not
      const path = route.path.startsWith('/') ? route.path : `/${route.path}`;
      return path;
    });
};

// Combine all protected routes
const PROTECTED_ROUTES = [
  ...extractRoutes(AdminRoutes),
  ...extractRoutes(HRRoutes),
  ...extractRoutes(AccountantRoutes),
  ...extractRoutes(MainRoutes)
];

// Remove duplicates
export const uniqueProtectedRoutes = [...new Set(PROTECTED_ROUTES)];

// Export for use in App.js
export default uniqueProtectedRoutes;